import React, { useState } from "react";
import { Button } from "@app/scripts/react-general-components/Button"
import { useLocaleContext } from "@app/scripts/react-providers/locales-vip"

type LockedPageProps = {
  code: string
  setIsLocked: (value: boolean) => void
  isCollection: boolean
}

export const LockedPage: React.FC<LockedPageProps> = ({code, setIsLocked, isCollection}) => {
  const { unlock, earlyAccess } = useLocaleContext()
  const [inputCode, setInputCode] = useState("")

  const isEarlyAccessPage = code && code.length === 4

  const handleInputChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    setInputCode(event.target.value)
  }

  const handleSubmit = (event: { preventDefault: () => void; }) => {
    event.preventDefault()
    
    // Check if the input code matches the provided code
    if(inputCode === code) {
      setIsLocked(false)
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if(event.key === 'Enter'){
      event.preventDefault()
      // Check if the input code matches the provided code
      if(inputCode === code) {
        setIsLocked(false)
      }
    }
  }

  return (
    <div className="container mx-auto flex justify-center items-center" style={{height: '50vh'}}>
      <div className="mx-auto flex flex-col my-10 px-5 space-y-4">
        <div className="mb-10">
          <h1 className="mb-4">
            { isEarlyAccessPage ? earlyAccess?.heading || "Early access" : unlock?.heading || "Exclusive Page" }
          </h1>
          <div className="text-lg">
            <p>{ isEarlyAccessPage 
              ? earlyAccess?.message || "A code is required for early access to this page. Please enter the code you received."
              : unlock?.message || "This page is currently locked and available only to our logged-in members until the unlock date. If you are a member, please log in to get a sneak peek of this exclusive page. If not, don't miss out - register now and enjoy the benefits of membership!" }</p>
          </div>
        </div>
        { isEarlyAccessPage
          ? <ui-form className="flex flex-col space-y-2 items-center">
              <form className="_fiel half flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-4">
                <input 
                  type="text"
                  className="_field__input"
                  value={inputCode} 
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  pattern="[A-Za-z0-9]{4}"
                  maxLength={10}
                  required
                  placeholder="Please enter the unlock code."
                />
                <Button type="button" onClick={handleSubmit} label={`Unlock this ${isCollection ? 'Collecion' : 'Page'}`} variant="secondary" className="mx-auto"/>
              </form>
            </ui-form>
          : <div className="flex flex-col space-y-2 items-center">
              <Button type="button" label="Create account" variant="secondary" className="add-to-cart" href="/account/register" />
              <div className="">
                <span className="mr-1">Already have an account?</span>
                <Button className="product-stl__product-view-details" href="/account/login" variant="text" label="Login" />
              </div>
            </div>
        }
      </div>
    </div>
  )
}